import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../assets/css/layout/customer/CustomerSidebar.css";

const navItems = [
  {
    label: "Dashboard",
    to: "/customer/dashboard",
    icon: (
      <svg
        className="sgc-sidebar-nav-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
    ),
  },

  {
    label: "Book New Appointment",
    to: "/customer/book",
    icon: (
      <svg
        className="sgc-sidebar-nav-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="16" />
        <line x1="8" y1="12" x2="16" y2="12" />
      </svg>
    ),
  },
    {
    label: "My Appointments",
    to: "/customer/appointments",
    icon: (
      <svg
        className="sgc-sidebar-nav-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    label: "My Treatments",
    to: "/customer/treatments",
    icon: (
      <svg
        className="sgc-sidebar-nav-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M12 2a5 5 0 1 1 0 10A5 5 0 0 1 12 2z" />
        <path d="M12 14c-5.33 0-8 2.67-8 4v2h16v-2c0-1.33-2.67-4-8-4z" />
      </svg>
    ),
  },
  {
    label: "Deals & Offers",
    to: "/customer/deals",
    icon: (
      <svg
        className="sgc-sidebar-nav-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
        <line
          x1="7"
          y1="7"
          x2="7.01"
          y2="7"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    label: "MyDeals",
    to: "/customer/my-deals",
    icon: (
      <svg
        className="sgc-sidebar-nav-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </svg>
    ),
  },
  {
    label: "Support",
    to: "/customer/support",
    icon: (
      <svg
        className="sgc-sidebar-nav-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <line
          x1="12"
          y1="17"
          x2="12.01"
          y2="17"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
];

const CustomerSidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("customerEmail");
    localStorage.removeItem("customerId");
    localStorage.removeItem("customer");
    localStorage.removeItem("customerPassword");
    // localStorage.removeItem("token");

    navigate("/customer/login");
  };

   const handleGoHome = () => {
    navigate("/");
  };

   return (
    <>
      <div
        className={`sgc-sidebar-overlay ${
          !isOpen ? "sgc-sidebar-overlay-hidden" : ""
        }`}
        onClick={onClose}
      />

      <aside className={`sgc-sidebar ${isOpen ? "sgc-sidebar-open" : ""}`}>
        <div
          className="sgc-sidebar-brand"
          onClick={handleGoHome}
          style={{ cursor: "pointer" }}
        >
          <div className="sgc-sidebar-brand-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
              <circle cx="12" cy="9" r="2.5" fill="currentColor" />
            </svg>
          </div>

          <div className="sgc-sidebar-brand-text">
            <p className="sgc-sidebar-brand-name">Estetica Skin & Laser</p>
            <p className="sgc-sidebar-brand-subtitle">Customer Portal</p>
          </div>
        </div>

        <nav className="sgc-sidebar-nav">
          <p className="sgc-sidebar-section-label">Main Menu</p>

          {navItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.to}
              className={({ isActive }) =>
                `sgc-sidebar-nav-item ${
                  isActive ? "sgc-sidebar-active" : ""
                }`
              }
              onClick={onClose}
            >
              {item.icon}
              <span className="sgc-sidebar-nav-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sgc-sidebar-footer">
          <div className="sgc-sidebar-divider"></div>

          <div
            className="sgc-sidebar-footer-item"
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
          >
            <span className="sgc-sidebar-footer-label">Logout</span>
          </div>
        </div>
      </aside>
    </>
  );
};

export default CustomerSidebar;